import { Label } from "@/components/ui/label";

export const fieldInputCls =
  "bg-[#090A0F] border-[#282D3D] focus-visible:ring-[#FF3B30] focus-visible:ring-offset-0 font-mono rounded-sm h-10";

export const Field = ({ label, children, className = "" }) => (
  <div className={`space-y-1.5 ${className}`}>
    <Label className="text-[11px] font-semibold uppercase tracking-wider font-mono text-slate-400">{label}</Label>
    {children}
  </div>
);
